import { useEffect, useMemo, useState } from 'react';
import { CommonProperties } from '../../common/common.interfaces';
import { SalsifyLocalizationsTableRow } from '../salsify.interfaces';
import { DateTime } from 'luxon';
import JSONPretty from 'react-json-pretty';
import { API_PROD_URL } from '../..';
import { useLoading } from '../../loading/LoadingContext';
import { useUserContext } from '../../user/UserContext';
import { apiFetch } from '../../utility/fetch';

interface SalsifyLocalizationProps extends CommonProperties {}

export default function SalsifyLocalization(props: SalsifyLocalizationProps) {
  const {toggleLoading, changeStep, changeSubStep} = useLoading()
  const {userData} = useUserContext()
  const [rows, setRows]: [SalsifyLocalizationsTableRow[], any] = useState([])

  const [refresh, setRefresh] = useState(DateTime.now().toLocaleString(DateTime.TIME_WITH_SECONDS))

  useEffect(() => {
    const load = async function(){
      changeStep('Salsify Sync')
      changeSubStep('Loading localization records')
      toggleLoading(true)

      const response = await apiFetch<SalsifyLocalizationsTableRow[]>({
        endpoint: 'azureTables',
        method: 'GET',
        accessToken: userData.accessToken,
        baseUrlOverride: API_PROD_URL,
        params: [
          {key: 'table', value: 'salsifyLocalizations'}
        ]
      })
      console.log(response.body)
      setRows(response.body)

      toggleLoading(false)
    }
    load()
  }, [refresh])

  const view = useMemo(() => {
    if(!rows || rows.length === 0) return

    return <div>
      <span className='beacon-label'>THESE RECORDS PREPARE THE FOLLOWING PRODUCT FIELDS FOR SALSIFY SINCE THEY REQUIRE LOCALIZATION OBJECTS. HAVE THE TECH TEAM ADD, OR MODIFY, THESE VALUES. FOR EXAMPLE: <JSONPretty data={"\"Master_Case_Weight__c\": {\"en-US\": 14.4}"}/></span>
      <table className='flexport-table'>
      <thead>
        <tr className="sticky-row-2">
          <th></th>
          <th>LOCALIZATION</th>
          <th>FIELD TO LOCALIZE</th>
          <th>UPDATED</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, index) => (
          <tr key={index}>
            <td><span className='beacon-label'>{index+1}</span></td>
            <td><span className='beacon-label'>{r.partitionKey}</span></td>
            <td><span className='beacon-label'>{r.rowKey}</span></td>
            <td><span className='beacon-label'>{DateTime.fromISO(r.timestamp).setZone('America/Chicago').toFormat('MM/dd/yyyy t')}</span></td>
          </tr>
        ))}
      </tbody>
      </table>
    </div>
  }, [rows])

  return view
}